var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Practice/AddPractice/index.tsx";
import React, { useMemo, useState } from 'react';
import Wizard from 'Components/wizard';
import WizardMainContainer from 'Components/wizard/WizardMainContainer';
import AddPracticeFirstStep from './steps/AddPracticeFirstStep';
import AddPracticeSecondStep from './steps/AddPracticeSecondStep';
const AddPractice = () => {
  const [loading] = useState(false);
  const makeSteps = useMemo(() => {
    return [{
      component: AddPracticeFirstStep,
      componentName: 'AddPracticeFirstStep'
    }, {
      component: AddPracticeSecondStep,
      componentName: 'AddPracticeSecondStep'
    }];
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(WizardMainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Wizard, {
    steps: makeSteps,
    loading: loading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  })));
};
export default AddPractice;